var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66622 8.83332H8.49955V8.49999H8.66622H9.99955C10.0916 8.49999 10.1662 8.57459 10.1662 8.66665V13.3333V13.8333H10.6662H11.3329H11.4996V14.1667H11.3329H9.99955H8.66622H8.49955V13.8333H8.66622H9.33288H9.83288V13.3333V9.33332V8.83332H9.33288H8.66622ZM1.66895 9.99963C1.66895 5.39886 5.39861 1.66919 9.99939 1.66919C14.6002 1.66919 18.3298 5.39886 18.3298 9.99963C18.3298 14.6004 14.6002 18.3301 9.99939 18.3301C5.39862 18.3301 1.66895 14.6004 1.66895 9.99963ZM9.99939 1.93585C5.54589 1.93585 1.93561 5.54614 1.93561 9.99963C1.93561 14.4531 5.54588 18.0635 9.99939 18.0635C14.4529 18.0635 18.0631 14.4531 18.0631 9.99963C18.0631 5.54614 14.4529 1.93585 9.99939 1.93585ZM10.4994 5.99999C10.4994 6.27612 10.2755 6.49999 9.9994 6.49999C9.72327 6.49999 9.4994 6.27612 9.4994 5.99999C9.4994 5.72384 9.72326 5.49999 9.9994 5.49999C10.2755 5.49999 10.4994 5.72384 10.4994 5.99999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircled);
export default __webpack_public_path__ + "static/media/info-circled.58f0292f5e8c30d4e6ea5da83618146d.svg";
export { ForwardRef as ReactComponent };